if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      /** Custom Musaib's Code **/ 
      if(this.querySelector('button[disabled][name="add"]')){ document.querySelector('.atc-sticky-container button')?.setAttribute('disabled','disabled'); } 
     
      this.hideErrors = this.dataset.hideErrors === 'true';
      document.onscroll = ()=>{
        let status = this.hideShowSticyBtn();
       if(status){document.querySelector('.atc-sticky-container').classList.add('hidden');}
        else { document.querySelector('.atc-sticky-container').classList.remove('hidden'); }
      }
     this.buyItNow = this.querySelector('shopify-buy-it-now-button');
      if(this.buyItNow){
        this.buyItNow.querySelector('button').classList.add('button','button--secondary');
         this.buyItNow.querySelector('button').innerText = '⚡ Buy Now';
      }
      this.permalink = this.querySelector('[data-cartpermalink]');
      if(this.permalink){
        this.permalink.addEventListener('click',(e)=>{
          e.preventDefault();
          e.stopImmediatePropagation();
          this.permalink.classList.add('loading');
          this.permalink.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          let variant_id =  this.form.querySelector('[name=id]').value;
          
          const formData = new FormData(this.form);
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(data =>{
         console.log(data); 
          let quick_checkout = document.querySelector('#CartDrawer [name="checkout"]');
               if (quick_checkout){
                 quick_checkout.removeAttribute('disabled');
                   quick_checkout.click();
                 }
        })
        .catch(error =>{
            console.log(error)
        })
        .finally(()=>{
          this.permalink.classList.remove('loading');
          this.permalink.querySelector('.loading-overlay__spinner').classList.add('hidden');
        })
          

          /**
          let propertiesData = '';
            formData.forEach((value,key)=>{
                if(key.includes('properties')){
                    let v = value.replaceAll(' ','+');
                    let k = key.split('[')[1].split(']')[0].replaceAll(' ','+');
                    let prop = `&items[][properties][${k}]=${v}`;
                    propertiesData += prop; 
                }
            });
          // let perlink_url_to_shopify_checkout =`/cart/add?items[][id]=${variant_id}&items[][quantity]=1${propertiesData}&return_to=/checkout`;
          // window.location.href = perlink_url;
          //  let perlink_url_to_quick_checkout =`/cart/add?items[][id]=${variant_id}&items[][quantity]=1${propertiesData}`;
               
          fetch(`${perlink_url_to_quick_checkout}`).then(r => {
              if(r.status == 200 || r.status == 302){
               let quick_checkout = document.querySelector('[name="checkout"]');
                     if (quick_checkout) {
                         quick_checkout.click();
                       }else{
                       window.location.href = "/checkout";
                     }
               }else{
                window.location.href = perlink_url_to_quick_checkout+"&return_to=/checkout";
               }
          }).catch(err=>{
               window.location.href = perlink_url_to_quick_checkout+"&return_to=/checkout";
          })
          **/  

        
        });
      }
      /** Custom Code end **/
    }
    

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
     hideShowSticyBtn(){
      let element = this.form;
       const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
    }
  });
}
